export const messages = {
  pl: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWAG: 'RWA-G - wisząca do złożenia',
      RWAB: 'RWA-B - wisząca do złożenia',
      RWA: 'RWA - wisząca do złożenia',
      RWG: 'RW-G - wisząca złożona',
      RWB: 'RW-B - wisząca złożona',
      RW: 'RW - wisząca złożona',
      RWD: 'RWD - wisząca złożona podwójna',
      RWDAG: 'RWDA-G - wisząca do złożonia podwójna',
      RKG: 'RK-G - wandaloodporna',
      RS: 'RS - stojąca do złożenia',
      RSP: 'RS...P - stojąca do złożenia (drzwi z perforacją)',
      ZRS: 'ZRS - stojąca złożona',
      // ---------------------------------------------------------- MENU
      nowa: 'Nowa',
      zapisz: 'Zapisz',
      otworz: 'Otwórz',
      o_programie: 'O programie',
      budowa_szafy: 'Budowa szafy',
      transport: 'Transport',
      wyslij_zapytanie: 'Uwagi klienta',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Rodzaj szafy RACK 19"',
      model_szafy: 'Model szafy RACK',
      model_akces: 'Akcesoria do szaf RACK',
      model_akces_zasilacze: 'Zasilacze do szaf RACK',
      model_akces_switche: 'Switche do szaf RACK',
      model_akces_obudowy: 'Obudowy do szaf RACK',
      same_akces: 'same akcesoria do wybranej szafy',
      rabat: 'Rabat',
      wysokosc_rabatu: 'Wysokość rabatu:',
      netto_po_rabacie: 'Wartość netto po rabcie',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Miejsca U',
      miejsce_urzadzenia: 'zajęte',
      miejsce_calosc: 'całość',
      miejsce_wolne: 'wolne',
      widok: 'Widok',
      przod: 'przód',
      tyl: 'tył',
      inny: 'inny',
      dodatkowe: 'Akcesoria poza "U"',
      puste_pola: 'puste pola',
      wyszukaj_produkt: 'wyszukaj produkt...',
      produkt_klienta: 'Własny produkt klienta',
      wynik: 'Podsumowanie',
      zamknij: 'zamknij',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Opis szafy',
      opis_akces: 'Opis akcesoriów',
      nazwa: 'Nazwa',
      kod: 'Kod',
      wymiary: 'Wymiary (WxHxD)',
      ilosc_u: 'Ilość U',
      waga: 'Waga netto',
      cena_detal: 'Cena netto detal',
      po_rabacie: 'po rabacie',
      cena: 'Cena [zł]',
      ilosc: 'Ilość',
      wydruk: 'wydruk',
      wartosc_netto: 'Wartość netto',
      karta: 'karta katalogowa',
      instrukcja: 'instrukcja',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'Program nie uwzględnia głębokości urzadzeń',
      dodanie_puste_pola: 'Możliwość dodawania pustych "U" dla lepszego uporządkowania urządzeń w szafie',
      info_RAWP: 'Panel dwóch wentylatorów z możliwością kaskadowego<br/>łączenia wentylatorów w zależności od głębokości szafy:<br>1x : głębokość 600<br>2x : głębokość 800<br>3x : głębokość 1000',
      full_place_front: 'Brak miejsca w szafie z przodu',
      full_place_back: 'Brak miejsca w szafie z tylu',
      collision: 'Możliwa kolizja produktów - przód / tyl - sprawdź głebokość',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: 'Transport szafy: paczka standardowa (30zł netto).',
      paczka_niestandardowa: 'Transport szafy: paczka niestandardowa (30zł netto).',
      paczka_na_palecie: 'Transport szafy: na palecie 120x80 (30zł netto).',
      akces_ARAD: 'Akcesoria do obudów ARAD/ARADS/ARAD-S/RAWO',
      program_confi_rack: 'O programie CONFI-RACK',
      widok_szafy: 'Widok szafy RACK',
      zestawienie_cenowe: 'Zestawienie cenowe',
      lista_produktow: 'LISTA PRODUKTÓW',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: 'PLN',
      mm: 'mm',
      kg: 'kg',
      szt: 'szt',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: 'Na potrzeby skonfigurowania sprzętowo-cenowego szaf RACK 19” stworzyliśmy dla Państwa program CONFI-RACK dostępny online na naszej stronie www.pulsar.pl.Jego prosta, intuicyjna obsługa pozwala na:<br>- szybkie wybranie odpowiedniej szafy RACK<br>- jednoznacznemu przyporządkowaniu akcesoriów do danej szafy<br>- przygotować wycenę detaliczną jak i uwzględnić przysługujący klientowi rabat<br>- wydrukować zestawienie cenowe i rozmieszczenie akcesoriów.',
      wersja_3_0: 'Wersja 3.0<br>W nowej wersji 3.0 CONFI-RACK dołożono następujące funkcje:<br>- podział produktów na grupy<br>- możliwość montażu elementów zarówno na przednich jak i tylnych profilach<br>- sortowanie produktów według kodu lub nazwy',
      wersja_2_1: 'Wersja 2.1<br>W nowej wersji 2.1 CONFI-RACK dołożono następujące funkcje:<br>- funkcja sortowania według nazw akcesorii<br>- funkcja sortowania według kodu akcesorii<br>- szybki podgląd akcesorii',
      wersja_2_0: 'Wersja 2.0<br>W wersji 2.0 CONFI-RACK dołożono następujące funkcje:<br>- funkcja zapisania konfiguracji szafy RACK na lokalny dysk<br>- funkcja wgrania do konfiguratora zapisanego projektu z dysku lokalnego- możliwość wysyłki na maile zapisanych projektów z dysku lokalnego<br>- możliwość wpisania adresu wysyłki szafy RACK i/lub akcesoriów- szacunkowe podanie ilości paczek / palet przy danej konfiguracji<br>- kontakt dla klienta odnośnie uwag do programu CONFI-RACK',
      start_confi: 'Rozpocznij konfigurację',
      wyprzedaz: 'WYPRZEDAŻ',
      promocja: 'PROMOCJA',
      autosave: 'zapis automatyczny'
    }
  },
  en: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - wall mounted, ready-to-assemble',
      RW: 'RW - wall mounted, fully assembled',
      RWD: 'RWD - double section, wall mounted, fully assembled',
      RWDAG: 'RWDA-G - double section, ready-to-assemble',
      RKG: 'RK-G - wandaloodporna',
      RS: 'RS - floor standing, ready-to-assemble',
      RSP: 'RS...P - floor standing, ready-to-assemble (perforated door)',
      ZRS: 'ZRS - floor standing, fully assembled',
      // ---------------------------------------------------------- MENU
      nowa: 'New',
      zapisz: 'Save',
      otworz: 'Open',
      o_programie: 'About program',
      budowa_szafy: 'Structure of the cabinet',
      transport: 'Transport',
      wyslij_zapytanie: 'Customer comments',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'The kind of the RACK 19" cabinet',
      model_szafy: 'Height of the RACK cabinet',
      model_akces: 'Accessories for RACK cabinets',
      model_akces_zasilacze: 'Power Supply for RACK cabinets',
      model_akces_switche: 'Switch for RACK cabinets',
      model_akces_obudowy: 'Enclosures for RACK cabinets',
      same_akces: 'only accessories',
      rabat: 'Discount',
      wysokosc_rabatu: 'Discount amount:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Cabinet space',
      miejsce_urzadzenia: 'devices',
      miejsce_calosc: 'totality',
      miejsce_wolne: 'free',
      widok: 'View',
      przod: 'front',
      tyl: 'back',
      inny: 'other',
      dodatkowe: 'Additional',
      puste_pola: 'empty spaces',
      wyszukaj_produkt: 'search product...',
      produkt_klienta: 'Client`s own product',
      wynik: 'Result',
      zamknij: 'close',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Description',
      opis_akces: 'Description of accessories',
      nazwa: 'Name',
      kod: 'Code',
      wymiary: 'Dimensions (WxHxD)',
      ilosc_u: 'Count U',
      waga: 'Weight (net)',
      cena_detal: 'Retail price (net)',
      po_rabacie: 'bonus',
      cena: 'Price',
      ilosc: 'Quantity',
      wydruk: 'print',
      wartosc_netto: 'Wartość netto',
      karta: 'data sheet',
      instrukcja: 'instruction',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'The program does not take into account the depth of the devices',
      dodanie_puste_pola: 'Empty U can be added to better organize devices in the cabinet',
      info_RAWP: 'A panel of two fans with the ability to cascade<br>the fans depending on the depth of the cabinet:<br>1x : depth 600<br>2x : depth 800<br>3x : depth 1000',
      full_place_front: 'Out of closet space in front',
      full_place_back: 'Out of closet space at the back',
      collision: 'Possible product collision - front / back - check depth',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Accessories for ARAD/ARADS/ARAD-S/RAWO enclosures',
      program_confi_rack: 'About program Confi-RACK',
      widok_szafy: 'View the cabinet',
      zestawienie_cenowe: 'Statement',
      lista_produktow: 'PRODUCTS LIST',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'pcs',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: 'For the purpose of configuring the equipment and price of RACK 19" cabinets, we have created for you the CONFI-RACK program available online on our website www.pulsar.pl. Its simple, intuitive operation allows you to:<br>- quick selection of the appropriate 19" RACK cabinet<br>- unambiguous assignment of accessories to a given cabinet<br>- prepare a retail valuation and take into account the customer`s rebate<br>- print a price list and placement of accessories. ',
      wersja_3_0: 'Version 3.0<br>The following features have been added to the new version 3.0 CONFI-RACK:<br>- division of products into groups<br>- the possibility of mounting elements on both the front and rear profiles<br>- sorting products by code or name ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  de: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - hängeschrankzur Montage',
      RW: 'RW - hängeschrankzur zusammengestellt',
      RWD: 'RWD - doppel-hängeschrankzur - zusammengestellt',
      RS: 'RS - stehschrank - zur Montage',
      ZRS: 'ZRS - stehschrank - zusammengestellt',
      // ---------------------------------------------------------- MENU
      nowa: 'Neu',
      zapisz: 'Speichern',
      otworz: 'Öffnen',
      o_programie: 'Über das Programm',
      budowa_szafy: 'Bauweise des Schrankes',
      transport: 'Transport',
      wyslij_zapytanie: 'Bemerkungen des Kunden',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Typ des RACK Schrankes 19"',
      model_szafy: 'Höhe des RACK Schrankes',
      model_akces: 'Zubehör für die RACK Schränke',
      model_akces_zasilacze: 'Netzteile für RACK-Schränke',
      model_akces_switche: 'Switchs für RACK-Schränke',
      model_akces_obudowy: 'RACK-Schrankgehäuse',
      same_akces: 'nur Zubehör',
      rabat: 'Rabatt',
      wysokosc_rabatu: 'Höhe des Rabatts:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Schrankraum',
      miejsce_urzadzenia: 'Geräte',
      miejsce_calosc: 'ganze',
      miejsce_wolne: 'kostenlos',
      widok: 'Ausblick',
      przod: 'Front',
      tyl: 'Zurück',
      inny: 'Andere',
      dodatkowe: 'Zusätzlich',
      puste_pola: 'leere Räume',
      wyszukaj_produkt: 'Produkt suchen...',
      produkt_klienta: 'Kunden eigenes Produkt',
      wynik: 'Ergebnis',
      zamknij: 'schließen',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Beschreibung die Schränke',
      opis_akces: 'Beschreibung des Zubehörs',
      nazwa: 'Name',
      kod: 'Code',
      wymiary: 'Abmessungen (BxHxT)',
      ilosc_u: 'Menge U',
      waga: 'Nettogewicht',
      cena_detal: 'Nettopreisdetail',
      po_rabacie: 'nach dem Rabatt',
      cena: 'Preis',
      ilosc: 'Anzahl',
      wydruk: 'ausdrucken',
      wartosc_netto: 'Nettowert',
      karta: 'datenblatt',
      instrukcja: 'betriebsanweisung',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'Das Programm berücksichtigt nicht die Tiefe der Geräte',
      dodanie_puste_pola: 'Leeres U kann hinzugefügt werden, um Geräte im Schrank besser zu organisieren',
      info_RAWP: 'Drucken oder als PDF speichern. Nach PDF exportieren Löschen der Konfiguration Ein Panel aus zwei Lüftern mit der Fähigkeit, die Lüfter abhängig von der Tiefe des Gehäuses zu kaskadieren.',
      full_place_front: 'Vorne aus dem Schrank',
      full_place_back: 'Nicht genügend Stauraum hinten',
      collision: 'Mögliche Produktkollision - Vorder- / Rückseite - Tiefe prüfen',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Zubehör für die ARAD/ARADS/ARAD-S/RAWO Gehäuse',
      program_confi_rack: 'Über das Programm Confi-RACK',
      widok_szafy: 'Sehen Sie sich den Schrank an',
      zestawienie_cenowe: 'Aussage',
      lista_produktow: 'PRODUKTLISTE',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: ' Um die Ausstattung und den Preis von RACK 19" -Schränken zu konfigurieren, haben wir für Sie das CONFI-RACK-Programm erstellt, das online auf unserer Website www.pulsar.pl verfügbar ist. Seine einfache, intuitive Bedienung ermöglicht Ihnen:<br>- schnelle Auswahl der geeignetes 19 "RACK-Gehäuse<br>- eindeutige Zuordnung von Zubehör zu einem bestimmten Schrank<br>- Erstellung einer Einzelhandelsbewertung und Berücksichtigung des Kundenrabatts<br>- Druck einer Preisliste und Platzierung des Zubehörs.',
      wersja_3_0: ' CONFI-RACK Version 3.0 Die neue Version 3.0 CONFI-RACK wurde um folgende Funktionen erweitert:<br>- Aufteilung der Produkte in Gruppen<br>- Möglichkeit der Montage von Elementen an den vorderen und hinteren Profilen<br>- Sortierung der Produkte nach Code oder Name ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  fr: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - Coffrets Muraux, Prets a Monter',
      RW: 'RW - Coffrets Muraux, Assemblés',
      RWD: 'RWD - Pivotants, Coffrets Muraux, Assemblés',
      RS: 'RS - Sur Pieds, Prets a Monter',
      ZRS: 'ZRS - Sur Pieds, Assemblés',
      // ---------------------------------------------------------- MENU
      nowa: 'Nouveau',
      zapisz: 'Sauvegarder',
      otworz: 'Ouvert',
      o_programie: 'À propos du programme',
      budowa_szafy: 'Construction du cabinet',
      transport: 'transport',
      wyslij_zapytanie: 'Feedback client',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Types de RACK 19"',
      model_szafy: 'Hauteur de l`armoire RACK',
      model_akces: 'Accessoires pour armoires RACK',
      model_akces_zasilacze: 'Alimentations pour armoires RACK',
      model_akces_switche: 'Switch pour armoires RACK',
      model_akces_obudowy: 'Armoires RACK',
      same_akces: 'même accessoires',
      rabat: 'réduction',
      wysokosc_rabatu: 'Montant de la remise:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Espace de l`armoire',
      miejsce_urzadzenia: 'dispositifs',
      miejsce_calosc: 'totalité',
      miejsce_wolne: 'libre',
      widok: 'Vue',
      przod: 'avant',
      tyl: 'dos',
      inny: 'autre',
      dodatkowe: 'Supplémentaire',
      puste_pola: 'espaces vides',
      wyszukaj_produkt: 'rechercher un produit...',
      produkt_klienta: 'Produit du client',
      wynik: 'résultat',
      zamknij: 'Fermer',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Description de Armoires',
      opis_akces: 'Description des accessoires',
      nazwa: 'nom',
      kod: 'code',
      wymiary: 'Dimensions (LxHxP)',
      ilosc_u: 'Quantité U',
      waga: 'Poids net',
      cena_detal: 'Détail du prix net',
      po_rabacie: 'après remise',
      cena: 'Prix',
      ilosc: 'nombre',
      wydruk: 'imprimer',
      wartosc_netto: 'Valeur nette',
      karta: 'fiche technique',
      instrukcja: 'instruction',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'Le programme ne prend pas en compte la profondeur des appareils',
      dodanie_puste_pola: 'Un U vide peut être ajouté pour mieux organiser les appareils dans l`armoire',
      info_RAWP: 'Un panneau de deux ventilateurs avec la possibilité de faire cascade les ventilateurs en fonction de la profondeur de l`armoire.',
      full_place_front: 'Espace de rangement insuffisant devant',
      full_place_back: 'Espace de rangement insuffisant à l`arrière',
      collision: 'Collision possible du produit - avant / arrière - vérifier la profondeur',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Accessoires pour boîtiers ARAD/ARADS/ARAD-S/RAWO',
      program_confi_rack: 'À propos du programme Confi-RACK',
      widok_szafy: 'Voir l`armoire',
      zestawienie_cenowe: 'Déclaration',
      lista_produktow: 'LISTE DE PRODUITS',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: ' Afin de configurer l’équipement et le prix des armoires RACK 19 ", nous avons créé pour vous le programme CONFI-RACK disponible en ligne sur notre site Web www.pulsar.pl. Son utilisation simple et intuitive vous permet de:<br>- sélectionner rapidement les armoire 19 "RACK appropriée<br>- attribution sans ambiguïté d`accessoires à une armoire donnée<br>- préparation d`une évaluation de vente au détail et prise en compte de la remise du client<br>- impression d`une liste de prix et placement des accessoires. ',
      wersja_3_0: 'Version 3.0<br>Les fonctionnalités suivantes ont été ajoutées à la nouvelle version 3.0 CONFI-RACK:<br>- division des produits en groupes<br>- possibilité de monter des éléments sur les profils avant et arrière<br>- trier les produits par code ou par nom ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  it: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - a muro da assemblare',
      RW: 'RW - a muro - assemblato',
      RWD: 'RWD - a muro - doppi - assemblati',
      RS: 'RS - da pavimento – da assemblare',
      ZRS: 'ZRS - da pavimento - assebmblati',
      // ---------------------------------------------------------- MENU
      nowa: 'Nuovo',
      zapisz: 'Salva',
      otworz: 'Aprilo',
      o_programie: 'Sul programma',
      budowa_szafy: 'Costruzione armadio',
      transport: 'Trasporto',
      wyslij_zapytanie: 'Feedback dei clienti',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Tipo dell`armadio RACK 19"',
      model_szafy: 'altezza armadio RACK',
      model_akces: 'Accessori per armadi RACK',
      model_akces_zasilacze: 'Alimentatore per armadi RACK',
      model_akces_switche: 'Switche per armadi RACK',
      model_akces_obudowy: 'Custodie per armadi RACK',
      same_akces: 'solo accessori',
      rabat: 'Sconto',
      wysokosc_rabatu: 'Totale sconto:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Spazio nell`armadio',
      miejsce_urzadzenia: 'dispositivi',
      miejsce_calosc: 'totale',
      miejsce_wolne: 'gratuito',
      widok: 'Vista',
      przod: 'davanti',
      tyl: 'indietro',
      inny: 'altro',
      dodatkowe: 'Aggiuntivo',
      puste_pola: 'spazi vuoti',
      wyszukaj_produkt: 'cerca prodotto...',
      produkt_klienta: 'Prodotto del cliente',
      wynik: 'Risultato',
      zamknij: 'vicino',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Descrizione del armadi',
      opis_akces: 'Descrizione degli accessori',
      nazwa: 'Nome',
      kod: 'Codice',
      wymiary: 'Dimensioni (WxHxD)',
      ilosc_u: 'Conta U',
      waga: 'Peso netto',
      cena_detal: 'Prezzo al dettaglio (netto)',
      po_rabacie: 'indennità',
      cena: 'Prezzo',
      ilosc: 'Numero',
      wydruk: 'stampare',
      wartosc_netto: 'Totalità netta',
      karta: 'scheda catalogo',
      instrukcja: 'istruzioni',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'Il programma non tiene conto della profondità dei dispositivi',
      dodanie_puste_pola: 'È possibile aggiungere una U vuota per organizzare meglio i dispositivi nell`armadio',
      info_RAWP: 'Un pannello di due ventole con la possibilità di mettere in cascata i ventilatori a seconda della profondità dell`armadio.',
      full_place_front: "Fuori dall'armadio di fronte",
      full_place_back: "Fuori dall'armadio sul retro",
      collision: 'Possibile collisione del prodotto - fronte / retro - controllare la profondità',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Accessori per custodie ARAD/ARADS/ARAD-S/RAWO',
      program_confi_rack: 'Sul programma Confi-RACK',
      widok_szafy: 'Visualizza l`armadietto',
      zestawienie_cenowe: 'Dichiarazione',
      lista_produktow: 'ELENCO PRODOTTI',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: ' Allo scopo di configurare l`apparecchiatura e il prezzo dei cabinet RACK 19 ", abbiamo creato per voi il programma CONFI-RACK disponibile online sul nostro sito web www.pulsar.pl. La sua semplice e intuitiva operazione ti consente di:<br>- Selezione rapida del cabinet rack 19 "appropriato<br>- Assegnazione inequivocabile degli accessori ad un determinato armadio<br>- preparare una valutazione al dettaglio e tenere conto del rimborso del cliente<br>- stampare un listino prezzi e il posizionamento degli accessori.',
      wersja_3_0: 'Versione 3.0<br>Le seguenti funzionalità sono state aggiunte alla nuova versione 3.0 CONFI-RACK:<br>- divisione dei prodotti in gruppi<br>- la possibilità di montare elementi su entrambi i profili anteriore e posteriore<br>- ordinare i prodotti per codice o nome ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  sk: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - závesná - na zloženie',
      RW: 'RW - závesná - zložená',
      RWD: 'RWD - závesná dvojitá - zložená',
      RS: 'RS - stojacia - na zloženie',
      ZRS: 'ZRS - stojacia - zložená',
      // ---------------------------------------------------------- MENU
      nowa: 'Nový',
      zapisz: 'Uložiť',
      otworz: 'Otvor to',
      o_programie: 'O programe',
      budowa_szafy: 'Poskladanie skrine',
      transport: 'Preprava',
      wyslij_zapytanie: 'Poznámky zákazníka',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Druh skrine RACK 19"',
      model_szafy: 'Výška skrine RACK',
      model_akces: 'Príslušenstvo do skríň RACK',
      model_akces_zasilacze: 'Zdroje do skríň RACK',
      model_akces_switche: 'Switche do skríň RACK',
      model_akces_obudowy: 'Skrinky do skríň RACK',
      same_akces: 'iba príslušenstvo',
      rabat: 'Rabat',
      wysokosc_rabatu: 'Výška rabatu:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Priestor skrinky',
      miejsce_urzadzenia: 'zariadenia',
      miejsce_calosc: 'celý',
      miejsce_wolne: 'zadarmo',
      widok: 'Pohľad',
      przod: 'predný',
      tyl: 'zadný',
      inny: 'iný',
      dodatkowe: 'Dodatočné',
      puste_pola: 'prázdne miesta',
      wyszukaj_produkt: 'vyhľadať produkt...',
      produkt_klienta: 'Vlastný produkt zákazníka',
      wynik: 'Výsledok',
      zamknij: 'Zavrieť',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Popis skrine',
      opis_akces: 'Popis príslušenstva',
      nazwa: 'Názov',
      kod: 'Označenie',
      wymiary: 'Rozmery (WxHxD)',
      ilosc_u: 'Počet U',
      waga: 'Hmotnosť netto',
      cena_detal: 'Cena netto detailne',
      po_rabacie: 'po rabate',
      cena: 'Cena [€]',
      ilosc: 'počet',
      wydruk: 'vytlačiť',
      wartosc_netto: 'Hodnota netto',
      karta: 'datasheet',
      instrukcja: 'manuál',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'Program nezohľadňuje hĺbku zariadení',
      dodanie_puste_pola: 'Na lepšie usporiadanie zariadení v skrini je možné pridať prázdne písmeno U.',
      info_RAWP: 'Panel dvoch ventilátorov s možnosťou kaskádového spájania ventilátorov v závislosti od hĺbky skrine.',
      full_place_front: 'Out of closet space in front',
      full_place_back: 'Out of closet space at the back',
      collision: 'Možná kolízia produktu - predná / zadná - skontrolovať hĺbku',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Príslušenstvo pre skrinky ARAD/ARADS/ARAD-S/RAWO',
      program_confi_rack: 'O programe Confi-RACK',
      widok_szafy: 'Pohľad na skrinku',
      zestawienie_cenowe: 'Vyhlásenie',
      lista_produktow: 'ZOZNAM PRODUKTOV',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: 'EUR',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: ' Na vytvorenie hardvérovej konfigurácie a cenovej ponuky skríň RACK 19” sme pre Vás pripravili program CONFI-RACK dostupný online na našej stránke www.pulsar.pl. Jeho jednoduchá a intuitívna obsluha umožňuje:<br>- rýchly výber zodpovedajúcej skrine RACK 19”,<br>- výber správneho príslušenstva pre danú skriňu,<br>- prípravu podrobnej cenovej ponuky so zohľadnením rabatu pre zákazníka,<br>- tlač cenovej ponuky a zobrazenia rozmiestnenia príslušenstva. ',
      wersja_3_0: 'Verzia 3.0<br>The following features have been added to the new version 3.0 CONFI-RACK:<br>- division of products into groups<br>- the possibility of mounting elements on both the front and rear profiles<br>- sorting products by code or name ',
      wersja_2_1: 'Verzia 2.1<br>V novej verzii 2.1 CONFI-RACK boli pridané nasledujúce funkcie:<br>- funkcia triedenia podľa názvov príslušenstva,<br>- funkcia triedenia podľa označenia príslušenstva,<br>- rýchle zobrazenie príslušenstva ',
      wersja_2_0: 'Verzia 2.0<br>V verzii 2.0 CONFI-RACK boli pridané nasledujúce funkcie:<br>- funkcia zapísania konfigurácie skrine RACK na lokálny disk,<br>- funkcia načítania do konfigurátora zapísaného projektu z lokálneho disku,<br>- možnosť zasielania na e-mail zapísaných projektov z lokálneho disku,<br>- možnosť zadania adresy doručenia skrine RACK a/alebo príslušenstva,<br>- výpočet počtu balíkov / paliet pri danej konfigurácii,<br>- možnosť zasielania poznámok ohľadom programu CONFI-RACK',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  es: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - colgante - listo para montar',
      RW: 'RW - colgante - completamente montado',
      RWD: 'RWD - colgante, doble - completamente montado',
      RS: 'RS - de pie - listo para montar',
      ZRS: 'ZRS - de pie - completamente montado',
      // ---------------------------------------------------------- MENU
      nowa: 'Nuevo',
      zapisz: 'Ahorrar',
      otworz: 'Abierto',
      o_programie: 'Sobre el programa',
      budowa_szafy: 'Construcción del gabinete',
      transport: 'transporte',
      wyslij_zapytanie: 'Comentarios del cliente',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Tipos de RACK 19"',
      model_szafy: 'Altura del armario RACK',
      model_akces: 'Accesorios para gabinetes RACK',
      model_akces_zasilacze: 'De alimentación para armarios RACK',
      model_akces_switche: 'Switches para armarios RACK',
      model_akces_obudowy: 'Armarios de armario RACK',
      same_akces: 'mismos accesorios',
      rabat: 'descuento',
      wysokosc_rabatu: 'Cantidad de descuento:',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Espacio del gabinete',
      miejsce_urzadzenia: 'dispositivos',
      miejsce_calosc: 'entero',
      miejsce_wolne: 'libre',
      widok: 'Ver',
      przod: 'frente',
      tyl: 'trasero',
      inny: 'otro',
      dodatkowe: 'Adicional',
      puste_pola: 'espacios vacíos',
      wyszukaj_produkt: 'buscar producto...',
      produkt_klienta: 'Producto del cliente',
      wynik: 'resultado',
      zamknij: 'cerca',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Descripción del armario',
      opis_akces: 'Descripción de accesorios',
      nazwa: 'nombre',
      kod: 'código',
      wymiary: 'Dimensiones (WxHxD)',
      ilosc_u: 'Cantidad U',
      waga: 'Peso neto',
      cena_detal: 'Detalle del precio neto',
      po_rabacie: 'después del reembolso',
      cena: 'Precio',
      ilosc: 'número',
      wydruk: 'impresión',
      wartosc_netto: 'Valor neto',
      karta: 'ficha técnica',
      instrukcja: 'manual de usuario',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'El programa no tiene en cuenta la profundidad de los dispositivos.',
      dodanie_puste_pola: 'Se puede agregar una U vacía para organizar mejor los dispositivos en el gabinete',
      info_RAWP: 'Un panel de dos ventiladores con la capacidad de conectar en cascada los ventiladores dependiendo de la profundidad del gabinete.',
      full_place_front: 'Fuera del espacio del armario en el frente',
      full_place_back: 'No hay espacio en el armario en la parte posterior',
      collision: 'Posible colisión del producto - frontal / posterior - comprobar profundidad',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'Accesorios para armarios ARAD/ARADS/ARAD-S/RAWO',
      program_confi_rack: 'Sobre el programa Confi-RACK',
      widok_szafy: 'Ver el gabinete',
      zestawienie_cenowe: 'Declaración',
      lista_produktow: 'LISTA DE PRODUCTOS',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: ' Para configurar el hardware y el precio de los armarios RACK de 19 "que hemos creado para. Su programa CONFI-RACK está disponible en línea en nuestro sitio web www.pulsar.pl. Su operación simple e intuitiva le permite:<br>- selección rápida del gabinete RACK apropiado de 19" <br>- Asignación inequívoca de accesorios a un armario determinado<br>- preparar una valoración minorista y tener en cuenta la devolución del cliente<br>- imprimir una lista de precios y la colocación de accesorios. ',
      wersja_3_0: 'Versión 3.0<br>La nueva versión 3.0 de confi-RACK-atención ha sido las siguientes funciones:<br>- distribución de productos en el grupo<br>- la capacidad de montar los componentes en los perfiles de la parte delantera y trasera<br>- productos ordenar por nombre o código ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  },
  hu: {
    message: {
      title: 'CONFI-RACK PULSAR',
      RWA: 'RWA - fali rögzítés, lapraszerelt',
      RW: 'RW - fali rögzítés, készre szerelt',
      RWD: 'RWD - kettős osztású, fali rögzítés készre szerelt',
      RS: 'RS - álló, lapraszerelt',
      ZRS: 'ZRS - álló, készre szerelt',
      // ---------------------------------------------------------- MENU
      nowa: 'Új',
      zapisz: 'Mentés',
      otworz: 'Nyisd ki',
      o_programie: 'A programról',
      budowa_szafy: 'A szekrény szerkezete',
      transport: 'szállítás',
      wyslij_zapytanie: 'Megjegyzés Kliens',
      // ---------------------------------------------------------- DANE WEJŚCIOWE
      rodzaj_szafy: 'Milyen típusú 19"-es RACK szekrény',
      model_szafy: 'A RACK szekrény magassága',
      model_akces: 'A RACK szekrény kiegészítői',
      model_akces_zasilacze: 'A RACK szekrényhez való tápegységek',
      model_akces_switche: 'A RACK szekrényhez való switchek',
      model_akces_obudowy: 'A RACK szekrények burkolatai',
      same_akces: 'csak kiegészítők',
      rabat: 'Kedvezmény',
      wysokosc_rabatu: 'A kedvezmény összege',
      // ---------------------------------------------------------- INTERFEJS
      miejsce: 'Szekrény hely',
      miejsce_urzadzenia: 'eszközök',
      miejsce_calosc: 'egész',
      miejsce_wolne: 'ingyenes',
      widok: 'Látvány',
      przod: 'Elől',
      tyl: 'Hátul',
      inny: 'Más',
      dodatkowe: 'További',
      puste_pola: 'üres helyek',
      wyszukaj_produkt: 'termék keresése...',
      produkt_klienta: 'A kliens terméke',
      wynik: 'Eredmény',
      zamknij: 'Bezárás',
      // ---------------------------------------------------------- OKIENKO OPIS
      opis: 'Leírás',
      opis_akces: 'A kiegészítők leírása',
      nazwa: 'Név',
      kod: 'Kód',
      wymiary: 'Méretek (SzxMaxMé)',
      ilosc_u: 'U kiszámítása',
      waga: 'Nettó súly',
      cena_detal: 'Kiskereskedelmi ár (nettó)',
      po_rabacie: 'Bónusz',
      cena: 'Ár',
      ilosc: 'Mennyiség',
      wydruk: 'nyomtatás',
      wartosc_netto: 'Összesen nettó',
      karta: 'Adatlap',
      instrukcja: 'Útmutató',
      // ---------------------------------------------------------- TOOLTIPS INFORMACJE
      glebokosc_urzadzen: 'A program nem veszi figyelembe az eszközök mélységét',
      dodanie_puste_pola: 'Üres U hozzáadható az eszközök jobb rendezéséhez a szekrényben',
      info_RAWP: 'Két ventilátoros központ, mely képes lépcsőzetesen elhelyezni a ventilátorokat a szekrény mélységétől függően.',
      full_place_front: 'Elöl a szekrényben nincs hely',
      full_place_back: 'Hátul nincs hely a szekrényben',
      collision: 'Lehetséges termékütközés - elöl / hátul - ellenőrizze a mélységet',
      // ---------------------------------------------------------- OPISY DODATKOWE
      paczka_standard: '',
      paczka_niestandardowa: '',
      paczka_na_palecie: '',
      akces_ARAD: 'ARAD/ARADS/ARAD-S/RAWO dobozok kiegészítői',
      program_confi_rack: 'A Confi-RACK programról',
      widok_szafy: 'Tekintse meg a szekrényt',
      zestawienie_cenowe: 'Nyilatkozat',
      lista_produktow: 'TERMÉKEK LISTÁJA',
      // ---------------------------------------------------------- JEDNOSTKI
      zl: '€',
      mm: 'mm',
      kg: 'kg',
      szt: 'kg',
      // ---------------------------------------------------------- INFORMACJE WERSJA
      info_ogolne: 'A 19" RACK szekrényekhez készített felszereltség- és ár konfigurátort a számítások egyszerűsítése érdekében készítettük. A program elérhető online a www.pulsar.pl weboldalon. Egyszerűen kezelhető, segítségével könnyűvé válik kiválasztani a megfelelő RACK szekrényt - hozzárendelni a megfelelő kiegészítőket, kiszámolni az árat és a kedvezményeket, kinyomtatni az árlistát és a kiegészítők elhelyezését.',
      wersja_3_0: 'CONFI-RACK verzió: 3.0 A következő tulajdonságokkal egészítették ki a 3.0 CONFI-RACK programot: termékek csoportosítása, az elemek első és hátsó profilra felszerelhetősége, a termékek név vagy kód szerinti rendezhetősége. ',
      wersja_2_1: '',
      wersja_2_0: '',
      start_confi: 'Configuration starting',
      wyprzedaz: 'PRODUCT ON SALE',
      promocja: 'PROMOTION',
      autosave: 'autosave'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/messages.js